import Color from 'color';

const MIN_DARK_CONTRAST = 1.29;

const isColorLight = (color: string) => Color(color).contrast(Color('white')) < MIN_DARK_CONTRAST;

export default isColorLight;
